import BaseClient from '../base/baseClient';
import endpoint from '../../features/endPoints/ecommEndpoints';

const ViewPaymentMethodsClient = async (requestBody, apiAbortSignal = null) => {
    const { post: postClient } = BaseClient();
    try {
        let options = {};
        if(apiAbortSignal != null){
            options.signal = apiAbortSignal;
        }
        return await postClient(process.env.REACT_APP_ECOMM_URL + endpoint.paymentMethods(), requestBody, options, true);
    } catch (error) {
        return { error: 'Some error occured. Please try again' };

    }
};

export default ViewPaymentMethodsClient;